import { Component, OnInit, Inject } from '@angular/core';
import { BillingConceptService } from '../../../services/billing/billing-concept.service';
import { FilterService } from '../../../services/filter.service';
import { AuthService } from '../../../services/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BillingConceptFilter } from '../../../model/billing/billing-concept-filter';
import { ServiceFilter } from '../../../model/service-filter';
import { AliquotTax } from '../../../model/aliquot-tax';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CompanyFilter } from '../../../model/company-filter';
import { CompanyService } from '../../../services/company.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { TaxType } from 'src/app/enums/tax-type.enum';
import { BillingInvoiceItemEditInfo } from '../../../model/billing/billing-invoice-item-edit-info';
import { ValorizationItemAdjustment } from '../../../model/valorization-item-adjustment';

class BillingInvoiceItemEdit implements BillingInvoiceItemEditInfo {
  public Amount: number;
  public AliquotTax: AliquotTax;
  public Protocol: string;
  public PatientFullName: string;
  public  PracticeName: string;
  public RightsEntityAmount: number;
  public FeeEntityAmount: number;
  public ModuleEntityAmount: number;
  public SupplieEntityAmount: number;
  public TaxAmount: number;
  public MedicalAppointmentProcedureId: number;
  public ValorizationItemId: number;
  public ValorizationItemAdjustment: ValorizationItemAdjustment;
  public Credential: string;
  public ServiceName: string;
  public CompanyName: string;
  public AmountDebit?: number;
  public DebitTypeId?: number;
  public DebitTypeName: string;
  public ProcedureInvoiceDate: string;
  public PlanErpCode: string;
  public EntityErpCode: string;
  public PracticeRegionId: number;
  public CompanyId: number;
  public ServiceId: number;
  public BillingConceptId: number;
  public BillingConceptName: string;
  public InternalCode: string;
  public ProcedureCode: string;
  public DebitTypeIdAmount: any;
}

@Component({
  selector: 'app-billing-ivoice-item-manual-dialog',
  templateUrl: './billing-ivoice-item-manual-dialog.component.html',
  styleUrls: ['./billing-ivoice-item-manual-dialog.component.css']
})
export class BillingIvoiceItemManualDialogComponent implements OnInit {

  form: FormGroup;
  billingConcepts: BillingConceptFilter[] = [];
  services: ServiceFilter[] = [];
  aliquotTaxs: AliquotTax[] = [];
  companies: CompanyFilter[] = [];
  loading: boolean;

  constructor( private billingConceptService: BillingConceptService,
               private companyService: CompanyService,
               private formBuilder: FormBuilder,
               private notificationToastService: NotificationToastService,
               public dialogRef: MatDialogRef<BillingIvoiceItemManualDialogComponent>,
               private filterService: FilterService,
               @Inject(MAT_DIALOG_DATA) public data: BillingInvoiceItemEditInfo) {

    this.form = this.formBuilder.group({
      Amount: [ '', Validators.required ],
      AliquotTax: [ '', Validators.required ],
      Service: [ '', Validators.required ],
      Company: [ '', Validators.required ],
      BillingConcept: [ '', Validators.required ],
    });

  }

  get f() { return this.form.controls; }

  async ngOnInit() {

    this.loading = true;

    try {

      this.companies = await this.companyService
        .getCompanyFilters();

      this.billingConcepts = await this.billingConceptService
        .getBillingConceptFilters();

      this.aliquotTaxs = await this.filterService
        .getAliquotsTax( TaxType.Iva );

      this.services = await this.filterService
        .getServicesFilter();

      if ( this.data ) {
        this.loadData();
      }

    } catch ( err ) {
      this.notificationToastService.error( JSON.stringify( err.error ), 'Facturación' );
    } finally {

      this.loading = false;
    }
  }

  loadData() {

    const concept = this.billingConcepts.find( b => b.Id === this.data.BillingConceptId);
    const aliquotTax = this.aliquotTaxs.find( b => b.Id === this.data.AliquotTax.Id);
    const service = this.services.find( b => b.Id === this.data.ServiceId);
    const company = this.companies.find( b => b.Id === this.data.CompanyId);
    const amount = this.data.Amount;

    this.form.patchValue({
      Amount: amount,
      AliquotTax: aliquotTax,
      Service: service,
      Company: company,
      BillingConcept: concept
    });

  }

  onNoClick () {
    this.dialogRef.close( null );
  }

  save() {
    if ( this.form.valid ) {

      const item  = this.data == null ? new BillingInvoiceItemEdit() : this.data;
      item.Amount = this.form.controls.Amount.value;
      item.AliquotTax = this.form.controls.AliquotTax.value;
      item.ServiceId = this.form.controls.Service.value.Id;
      item.ServiceName = this.form.controls.Service.value.Name;
      item.CompanyId = this.form.controls.Company.value.Id;
      item.CompanyName = this.form.controls.Company.value.Name;
      item.BillingConceptId = this.form.controls.BillingConcept.value.Id;
      item.BillingConceptName = this.form.controls.BillingConcept.value.Name;

      this.dialogRef.close( item );
    }
  }
}


